import { DropdownReducerActionTypes } from '../types/DropdownReducerActionTypes';
/**
 * An action dispatchable to DropdownReducer.
 * Fire when we want the dropdown in searching state
 *
 * @type {DropdownReducerAction}
 */
export var searchingAction = {
    type: DropdownReducerActionTypes.Searching,
};
//# sourceMappingURL=searchingAction.js.map